import App from 'apmui/App';
import EventTags from 'apmui/EventTags';
import { CHALLENGE } from './Model';
import { FormValidationContext } from 'apmui/components/form/Model';

const app = App.get();

const F5_CHALLENGE = '_F5_challenge';
const F5_VERIFY_PASSWORD = '_F5_verify_password';

function setError(detail: FormValidationContext, fieldName: string, error: string) {
    if (detail.errors) {
        detail.errors[fieldName] = error;
    }
}

app.subscribe(EventTags.FORM_VALIDATE, ({ detail }, store) => {
    if (store.pageType !== 'logon') {
        return;
    }

    const logon = store.logon;
    const fields = logon.form.fields;
    // Validate New Password
    if (
        logon.challenge &&
        logon.challenge.status === CHALLENGE.NEW_PASSWORD &&
        fields.length >= 2 &&
        fields[0].name === F5_CHALLENGE &&
        fields[1].name === F5_VERIFY_PASSWORD
    ) {
        if (fields[0].value !== fields[1].value) {
            setError(detail, fields[1].name, logon.form.passwordVerifyDontMatch!);
        }
    }
});

app.subscribe(EventTags.FORM_SUBMIT, ({ detail }, store) => {
    if (store.pageType !== 'logon') {
        return;
    }

    const logon = store.logon;
    const fields = logon.form.fields;
    // Validate New Password
    if (
        logon.challenge &&
        logon.challenge.status === CHALLENGE.NEW_PASSWORD &&
        fields.length >= 2 &&
        fields[0].name === F5_CHALLENGE &&
        fields[1].name === F5_VERIFY_PASSWORD
    ) {
        // if( externalWebHost.hasSetWebLogonPassword) ){
        //    externalWebHost.setWebLogonPassword)(inputs[0].value);
        // }
    }
});
